export default __webpack_public_path__ + "static/media/ho.d185bef0.jpg";